export default "__VITE_ASSET__pLB6zDoe__"